import React from 'react'

import { FieldWrapper } from './FieldWrapper'

export const createField = ({ Component }) => ({
  inputClassName,
  upper, bold = true, fontSize,
  ghostLabel,
  input, meta, label, labelProps, className, ...rest
}) => (rest.disabled && input.value === '' ? null : (
  <FieldWrapper
    upper={upper}
    bold={bold}
    fontSize={fontSize}
    label={label}
    meta={meta}
    input={input}
    required={rest.required}
    className={className}
    disabled={rest.disabled}
    ghostLabel={ghostLabel}
  >
    <Component
      {...input}
      {...rest}
      className={inputClassName}
      type={input.type || 'text'}
    />
  </FieldWrapper>
))
